import { render, staticRenderFns } from "./PaymentDetailsPanel.vue?vue&type=template&id=7c31a652&scoped=true&"
import script from "./PaymentDetailsPanel.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetailsPanel.vue?vue&type=style&index=0&id=7c31a652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c31a652",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c31a652')) {
      api.createRecord('7c31a652', component.options)
    } else {
      api.reload('7c31a652', component.options)
    }
    module.hot.accept("./PaymentDetailsPanel.vue?vue&type=template&id=7c31a652&scoped=true&", function () {
      api.rerender('7c31a652', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/PaymentDetailsPanel.vue"
export default component.exports